import Color from 'color';
import { ColorParam } from '../type/color';

export const isSaturated = (color: ColorParam): boolean => {
  // This helps us pick out black, white, and shades of grey
  const model = Color(color);
  const saturation = model.saturationl();
  const brightness = model.lightness();
  return saturation > 0 && brightness > 0 && brightness < 100;
};
